import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSnackBar } from '@angular/material/snack-bar';

import {
  MatPaginator,
  MatPaginatorModule,
  PageEvent,
} from '@angular/material/paginator';
import { CommonModule } from '@angular/common';
import { Vendor } from '../../models/vendor.model';
import { VendorService } from '../../services/vendor.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSort, MatSortModule, Sort } from '@angular/material/sort';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import { DeleteVendorDialogComponent } from './dialogs/delete-vendor/delete-vendor-dialog.component';
import { EditVendorDialogComponent } from './dialogs/edit-vendor/edit-vendor-dialog.component';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTableResponsiveModule } from '../../mat-table-responsive.module';

interface SearchFormControl {
  search: FormControl<string>;
}

export interface VendorTable {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  userRole: string;
  lastLoginDate: Date;
  status: string;
}

@Component({
  selector: 'app-vendors',
  standalone: true,
  imports: [
    MatTabsModule,
    MatTableModule,
    MatButtonModule,
    MatPaginatorModule,
    MatIconModule,
    MatProgressBarModule,
    CommonModule,
    MatSort,
    MatSortModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatTableResponsiveModule,
  ],
  templateUrl: './vendors.component.html',
  styleUrl: './vendors.component.scss',
})
export class VendorsComponent implements OnInit {
  loading: boolean = false;
  searchForm = new FormGroup({ search: new FormControl('') });

  displayedColumns: string[] = [
    'name',
    'User.FirstName',
    'User.LastName',
    'User.Email',
    'User.UserProfile.Phone',
    'studentAmbassador',
    'User.UserProfile.Street',
    'status',
    'manage',
  ];
  dataSource = new MatTableDataSource<Vendor>([]);
  totalCount: number = 0;

  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  queryParams = new Map<string, any>();

  page = {
    countRequested: 10,
    pageIndex: 1,
    items: [],
    totalCount: 0,
  };

  constructor(
    private vendorService: VendorService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.loading = true;
    this.vendorService.getAll(1).subscribe({
      next: (response) => {
        this.loading = false;
        this.dataSource = new MatTableDataSource(response.items);
        this.dataSource.paginator = this.paginator;
        this.totalCount = response.totalCount;
      },
      error: () => {
        this.snackBar.open(
          'An error occured while retrieving users. Please try again.',
          '',
          { duration: 3000 }
        );
      },
    });

    this.searchForm.controls.search.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((value) => {
        this.queryParams.set('name', value);

        this.getVendors();
      });
  }

  changePage(event: PageEvent): void {
    this.loading = true;
    this.page.countRequested = event.pageSize;
    this.page.pageIndex == event.pageIndex + 1;
    this.vendorService
      .getAll(event.pageIndex + 1, event.pageSize, this.queryParams)
      .subscribe({
        next: (response) => {
          this.loading = false;
          this.dataSource = new MatTableDataSource(response.items);
          this.totalCount = response.totalCount;
        },
        error: () => {
          this.snackBar.open(
            'An error occured while retrieving vendors. Please try again.',
            '',
            { duration: 3000 }
          );
        },
      });
  }

  getVendors() {
    this.vendorService
      .getAll(this.page.pageIndex, this.page.countRequested, this.queryParams)
      .subscribe({
        next: (response) => {
          this.loading = false;
          this.dataSource = new MatTableDataSource(response.items);
          this.totalCount = response.totalCount;
        },
        error: () => {
          this.snackBar.open(
            'An error occured while retrieving vendors. Please try again.',
            '',
            { duration: 3000 }
          );
        },
      });
  }

  openEditDialog(vendor: Vendor) {
    const dialogRefEdit = this.dialog.open(EditVendorDialogComponent, {
      height: '65%',
      width: '70%',
      data: { vendorIdToEdit: vendor.id },
    });

    dialogRefEdit.afterClosed().subscribe((result) => {
      this.getVendors();
    });
  }

  openDeleteDialog(vendor: any) {
    const dialogRefDelete = this.dialog.open(DeleteVendorDialogComponent, {
      data: { vendorId: vendor.id },
    });

    dialogRefDelete.afterClosed().subscribe((result) => {
      if (result) {
        this.snackBar.open(result.message, '', { duration: 4000 });
      }
      this.getVendors();
    });
  }

  sortChange(event: Sort) {
    this.queryParams.clear();
    if (event != undefined && event.direction != '') {
      var sort = `${event.active}%20${event.direction}`;
      this.queryParams.set('OrderBy', sort);
    }

    this.getVendors();
  }

  goToVendorRegister() {
    this.vendorService.getVendorRegisterURL().subscribe((data) => {
      window.location.href = data.url;
    });
  }
}
